import { render, staticRenderFns } from "./djghd.vue?vue&type=template&id=4a23007b&scoped=true"
import script from "./djghd.vue?vue&type=script&lang=js"
export * from "./djghd.vue?vue&type=script&lang=js"
import style0 from "./djghd.vue?vue&type=style&index=0&id=4a23007b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a23007b",
  null
  
)

export default component.exports